export default "__VITE_ASSET__FnKNSnxq__"